import { HttpErrorResponse } from '@angular/common/http';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ToastNotificationsService } from '@app/shared/services/toast-notifications/toast-notifications.service';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { StatementsFacade } from '@app/modules/businesses/services/statements.facade';
import { MyBusinessRoutes } from '../../interfaces/constants';
interface ImportResponse {
  id: string;
  success: boolean;
  feedbackUrl: string;
}

@Component({
  selector: 'sbnb-transactions-import',
  templateUrl: './transactions-import.component.html',
})
export class TransactionsImportComponent {
  selectedFile: File;
  feedbackUrl: string | null = null;
  transactionRoute = MyBusinessRoutes.Transactions;

  constructor(
    private router: Router,
    private statementsFacade: StatementsFacade,
    private toast: ToastNotificationsService
  ) {}

  closeModal() {
    this.router.navigate([this.transactionRoute]);
  }

  onFileSelected(files: File[]) {
    if (files && files.length > 0) {
      this.selectedFile = files[0];
      this.feedbackUrl = null;
    }
  }

  importFile() {
    if (!this.selectedFile) {
      return;
    }

    const formData = new FormData();
    formData.append('file', this.selectedFile);

    this.statementsFacade
      .importTransactions(formData)
      .pipe(
        catchError((error: HttpErrorResponse) => {
          this.feedbackUrl = error.error.feedback_url;

          return throwError(() => error);
        })
      )
      .subscribe({
        next: (response: ImportResponse) => {
          this.toast.success('Transactions imported successfully');
          this.closeModal();
        },
      });
  }

  downloadFeedbackFile() {
    if (!this.feedbackUrl) {
      return;
    }

    window.open(this.feedbackUrl, '_blank');
  }

  onFileRemoved() {
    this.selectedFile = null;
    this.feedbackUrl = null;
  }

  downloadFile(filename: string, url: string): void {
    this.statementsFacade.downloadFile(filename, url);
  }
}
